module.exports = __webpack_public_path__ + "img/logo.e5f93bc6.png";